<template>
  <div>
    <div style="display: flex">
      <div class="col" style="text-align: left">
        <ButtonMedium
          v-if="allows_crud && can_update"
          v-can="'teaching.add_matterevaluationbibliographicresource'"
          :tooltip_text="
            $t('reusable.common.addTooltip', {
              entity: $t(
                'matterProgram.matterProgramView.bibliographicResource'
              ),
            })
          "
          :click_button="
            () => $bvModal.show(`new-m_evaluation_bibliographic_resource-modal`)
          "
          :text_button="$t('reusable.common.add')"
          :icon="'plus'"
          :variant="'primary'"
        >
        </ButtonMedium>
      </div>
    </div>
    <GenericBTable
      :items="m_evaluation_bibliographic_resource"
      :pagination="m_evaluation_bibliographic_resource.length"
      :fields="MEvaluationBibliographicResourceFields"
      :filter="input_search"
      :filterCustom="filterCustom"
      @emitChangeSearchField="changeInputSearch"
      :show_pagination="true"
      :search_filter="true"
      :columns_display="false"
      :allows_crud="allows_crud"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template #cell(bibliographic_resource)="row">
        <RenderVHtml
          :content="
            getBibliographicResourceDescription(row.item.bibliographic_resource)
          "
        ></RenderVHtml>
      </template>
      <template v-if="allows_crud" #cell(actions)="row">
        <ButtonSmall
          v-if="can_update && allows_crud"
          :tooltip_text="
            $t('reusable.common.editTooltip', {
              entity: $t(
                'matterProgram.matterProgramView.bibliographicResource'
              ),
            })
          "
          :click_button="
            () =>
              $bvModal.show(
                `edit-m_evaluation_bibliographic_resource-modal-${row.item.id}`
              )
          "
          :class="``"
          :icon="'square'"
        ></ButtonSmall>
        <ButtonSmall
          v-if="can_delete && allows_crud"
          :click_button="() => askForDeleteMEvaBiblioResource(row.item.id)"
          :tooltip_text="
            $t('reusable.common.deleteTooltip', {
              entity: $t(
                'matterProgram.matterProgramView.bibliographicResource'
              ),
            })
          "
          :icon="'trash'"
        ></ButtonSmall>
        <b-modal
          :id="`edit-m_evaluation_bibliographic_resource-modal-${row.item.id}`"
          :title="
            $t('reusable.common.editTooltip', {
              entity: $t(
                'matterProgram.matterProgramView.bibliographicResource'
              ),
            })
          "
          size="md"
          hide-footer
        >
          <MEvaluationBibliographicResourceForm
            :MatterEvaBibliResource="row.item"
            :m_evaluation_id="m_evaluation_id"
            :bibliographic_resources="bibliographic_resources"
            :bibliographic_resource_types="bibliographic_resource_types"
            @updated="slotUpdatedMEvaBiblioResource"
          ></MEvaluationBibliographicResourceForm>
        </b-modal>
      </template>
    </GenericBTable>
    <b-modal
      :id="`new-m_evaluation_bibliographic_resource-modal`"
      :hide-footer="true"
      :title="$t('matterProgram.matterProgramView.createBibliographicResource')"
      size="lg"
    >
      <MEvaluationBibliographicResourceForm
        :m_evaluation_id="m_evaluation_id"
        :bibliographic_resources="bibliographic_resources"
        :bibliographic_resource_types="bibliographic_resource_types"
        @created="slotCreatedMEvaBiblioResource"
      ></MEvaluationBibliographicResourceForm>
    </b-modal>
  </div>
</template>

<script>
import { toast } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  name: "MEvaluationBibliographicResource",
  components: {
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    MEvaluationBibliographicResourceForm: () =>
      import("./MEvaluationBibliographicResourceForm"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    m_evaluation_id: {
      type: Number,
      required: true,
    },
    matter_id: {
      type: Number,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      required: true,
    },
    can_delete: {
      type: Boolean,
      required: true,
    },
    can_update: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      m_evaluation_bibliographic_resource: [],
      bibliographic_resources: [],
      bibliographic_resource_types: [],
      sortBy: "is_mandatory",
      sortDesc: false,
      input_search: "",
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
    }),
    MEvaluationBibliographicResourceFields() {
      const is_duoc_institution =
        this.institution && this.institution.internal_use_id == "duoc.cl";

      return [
        {
          key: "bibliographic_resource",
          label: this.$t(
            "matterProgram.matterProgramView.bibliographicResources"
          ),
          sortable: true,
          // La celda muestra la descripción del recurso, no su id
          sortByFormatted: (value, key, item) =>
            this.getBibliographicResourceDescription(item.bibliographic_resource),
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "details",
          label: this.$t("matterProgram.matterProgramView.details"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "is_mandatory",
          label: this.$t("matterProgram.matterProgramView.type"),
          sortable: true,
          tdClass: "text-center",
          formatter: (value) => {
            return value
              ? this.$t("matterProgram.matterProgramView.mandatoryBibliography")
              : this.$t(
                  "matterProgram.matterProgramView.complementaryBibliography"
                );
          },
          display_column: is_duoc_institution,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    getType(type) {
      return type
        ? this.$t("matterProgram.matterProgramView.mandatoryBibliography")
        : this.$t("matterProgram.matterProgramView.complementaryBibliography");
    },
    filterCustom(row) {
      if (
        this.$filtered(
          this.getBibliographicResourceDescription(row.bibliographic_resource),
          this.input_search
        ) ||
        this.$filtered(row.details, this.input_search) ||
        this.$filtered(this.getType(row.is_mandatory), this.input_search)
      ) {
        return true;
      } else {
        return false;
      }
    },
    slotCreatedMEvaBiblioResource(response) {
      this.m_evaluation_bibliographic_resource.push(response);
      this.$bvModal.hide("new-m_evaluation_bibliographic_resource-modal");
    },
    slotUpdatedMEvaBiblioResource(response) {
      const index = this.m_evaluation_bibliographic_resource.findIndex(
        (x) => x.id == response.id
      );
      if (index != -1) {
        this.m_evaluation_bibliographic_resource[index].bibliographic_resource =
          response.bibliographic_resource;
        this.m_evaluation_bibliographic_resource[index].details =
          response.details;
        this.m_evaluation_bibliographic_resource[index].is_mandatory =
          response.is_mandatory;

        this.$bvModal.hide(
          `edit-m_evaluation_bibliographic_resource-modal-${response.id}`
        );
      }
    },
    askForDeleteMEvaBiblioResource(matter_eva_biblio_resource_id) {
      this.$swal({
        title: this.$t("matterProgram.matterProgramView.confirmDeleteEntity", {
          entity: this.$t(
            "matterProgram.matterProgramView.bibliographicResource"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$restful
            .Delete(
              `/teaching/matter-evaluation-bibliographic-resource/${matter_eva_biblio_resource_id}/`
            )
            .then(() => {
              const index = this.m_evaluation_bibliographic_resource.findIndex(
                (x) => x.id == matter_eva_biblio_resource_id
              );
              if (index != -1) {
                this.m_evaluation_bibliographic_resource.splice(index, 1);
                toast(
                  this.$t(
                    "matterProgram.matterProgramView.bibliographicResourceDeleted"
                  )
                );
              }
            });
        }
      });
    },
    getBibliographicResourceDescription(id) {
      if (!id) return "";
      const bibliographic_resource = this.bibliographic_resources.find(
        (x) => x.id == id
      );
      if (bibliographic_resource) return bibliographic_resource.description;
      return "";
    },
    fetchMEvaluationBibliographicResource() {
      if (!isNaN(this.m_evaluation_id))
        this.$restful
          .GetAll(
            `/teaching/matter-evaluation-bibliographic-resource/?matter_evaluation=${this.m_evaluation_id}`
          )
          .then((response) => {
            this.m_evaluation_bibliographic_resource = response;
          });
    },
    fetchBibliographicResource() {
      this.$restful
        .GetAll(`/teaching/bibliographic-resource/?matter=${this.matter_id}`)
        .then((response) => {
          this.bibliographic_resources = response;
        });
    },
    fetchBibliographicResourceType() {
      this.$restful
        .GetAll(`/teaching/bibliographic-resource-type/`)
        .then((response) => {
          this.bibliographic_resource_types = response;
        });
    },
  },
  created() {
    this.fetchMEvaluationBibliographicResource();
    this.fetchBibliographicResource();
    this.fetchBibliographicResourceType();
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>

<style scoped>
</style>